module.exports = __webpack_public_path__ + "mysql-icon.svg?c8c4671f94081b3dd1ef75873dbc3c4b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skill-icons/mysql-icon.svg
// module id = 54
// module chunks = 0